import React from "react";

interface Props {
  selected: boolean;
  className?: string;
}

/// Shared radio indicator used by setting-row pickers (theme, bucket
/// auth method, etc). Pair this with a parent `<button>` or `<label>`
/// — Radio itself is presentational and doesn't own state or focus.
export const Radio: React.FC<Props> = ({ selected, className = "" }) => (
  <div
    className={`shrink-0 size-4 rounded-full border flex items-center justify-center transition-colors ${
      selected ? "border-accent" : "border-border hover:border-accent"
    } ${className}`}
  >
    {selected && <div className="size-2 rounded-full bg-accent" />}
  </div>
);
